import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './core/store';
import AppRouter from './core/AppRouter';
import './scss/style.scss';

const App = () => {
  useEffect(() => {
    document.title = 'Petition Manager';
  }, []);

  return (
    <Provider store={store}>
      <Router basename={process.env.REACT_APP_BASE_URL}>
        <AppRouter />
      </Router>
    </Provider>
  );
};

export default App;
